import { ApiHelper } from "../common/api.helper";

export class BaseService {
  protected apiHandler: ApiHelper;
  private apiUri: string;

  constructor({ uri }: any) {
    this.apiUri = uri;
    this.apiHandler = new ApiHelper({
      url: `${isDevelopment ? appServerUrl : ""}/api/`,
      headers: {},
    });
  }

  async getAll(params: any) {
    const {
      data = [],
      errors = [],
      recordsCount,
    }: any = await this.apiHandler.get(this.apiUri, { params });
    return { data, errors, recordsCount };
  }

  async getOne(id: string) {
    const { data, errors }: any = await this.apiHandler.get(`${this.apiUri}/${id}`);
    return { data, errors };
  }

  async save(payload: any) {
    const { data = {}, errors }: any = await this.apiHandler.post(this.apiUri, payload);
    return { data, errors };
  }

  async delete(ids: any) {
    const { data, errors }: any = await this.apiHandler.delete(this.apiUri, { ids });
    return { data, errors };
  }
  async duplicate(payload: any) {
    const { data = [], errors = [] }: any = await this.apiHandler.post(
      `${this.apiUri}/clone`,
      payload,
    );
    return { data, errors };
  }
}
